import React from 'react';
import { Card, CardContent } from '../../../../../../../components/ui/card';
import { Badge } from '../../../../../../../components/ui/badge';
import { AlertTriangle, CheckCircle, XCircle } from 'lucide-react';

interface ErrorDisplayProps {
    jobData: any;
}

interface WeldParameterError {
    job_number: string;
    weldXMLErrors: string;
    project_id: number;
    project_name: string;
    welding_system: string;
    pipe_name: string | null;
    parsedErrors: {
        errorMessages: string[];
        invalidPassZoneMapping: Array<{ [key: string]: string }>;
        invalidLimits: any[];
        hasInvalidPassName: boolean;
        hasInvalidZoneName: boolean;
        hasNumericPassError: boolean;
    };
}

const ErrorDisplay: React.FC<ErrorDisplayProps> = ({ jobData }) => {
    // This would typically come from the weldParameterErrors in your data structure
    // For now, we'll create a mock error display based on the structure you provided
    
    const mockErrors: WeldParameterError = {
        job_number: jobData.job_number,
        weldXMLErrors: "",
        project_id: 39,
        project_name: "",
        welding_system: "p600z",
        pipe_name: null,
        parsedErrors: {
            errorMessages: [
                "Duplicate pendant pass names used in different passes"
            ],
            invalidPassZoneMapping: [
                { "HT": "HP Top" },
                { "HM": "HP Middle" },
                { "HO": "HPOverhead" },
                { "HB": "HP Bottom" },
                { "OP": "last fill top" },
                { "ID": "last fill side" },
                { "OT": "last fill bot" }
            ],
            invalidLimits: [],
            hasInvalidPassName: false,
            hasInvalidZoneName: false,
            hasNumericPassError: false
        }
    };

    const hasErrors = mockErrors.parsedErrors.errorMessages.length > 0 || 
                     mockErrors.parsedErrors.invalidPassZoneMapping.length > 0 ||
                     mockErrors.parsedErrors.invalidLimits.length > 0;

    if (!hasErrors) {
        return (
            <Card>
                <div className="p-6">
                    <h2 className="text-lg font-semibold text-gray-900 flex items-center gap-2">
                        <CheckCircle className="h-5 w-5 text-green-600" />
                        Error Status - {jobData.job_number}
                    </h2>
                </div>
                <CardContent>
                    <div className="text-center py-8">
                        <CheckCircle className="h-16 w-16 mx-auto mb-4 text-green-500" />
                        <h3 className="text-lg font-medium text-gray-900 mb-2">No Errors Detected</h3>
                        <p className="text-gray-600">All welding parameters appear to be valid.</p>
                    </div>
                </CardContent>
            </Card>
        );
    }

    return (
        <div className="space-y-6">
            {/* Error Banner */}
            <Card className=" bg-red-50">
                <div className="p-6">
                    <h2 className="text-lg font-semibold text-red-900 flex items-center gap-2">
                        <AlertTriangle className="h-5 w-5" />
                        ERROR - Below errors detected, which may cause erroneous reporting
                    </h2>
                </div>
                <CardContent>
                    <div className="space-y-2">
                        {mockErrors.parsedErrors.errorMessages.map((message, index) => (
                            <div key={index} className="flex items-center gap-2 text-red-800">
                                <XCircle className="h-4 w-4" />
                                <span>{message}</span>
                            </div>
                        ))}
                    </div>
                </CardContent>
            </Card>

        </div>
    );
};

export default ErrorDisplay;
